import * as React from 'react';
import { make } from '../chunker';
import findByType from 'lib/findByType';
import ErrorReporter from 'app/components/ErrorReporter';

import type { DateSeparatorChunk, StreamItemsChunk, UnchunkedSequenceItems } from '../chunker';

type Props = {
  items: UnchunkedSequenceItems;
  children: React.ReactElement[];
};

const GapChunk = (_props: { children: (chunk: StreamItemsChunk) => React.ReactElement }) => null;
const DateChunk = (_props: { children: (chunk: DateSeparatorChunk) => React.ReactElement }) => null;
const MessageChunk = (_props: { children: (chunk: StreamItemsChunk) => React.ReactElement }) =>
  null;
const PhoneCallChunk = (_props: { children: (chunk: StreamItemsChunk) => React.ReactElement }) =>
  null;
const VideoChatChunk = (_props: { children: (chunk: StreamItemsChunk) => React.ReactElement }) =>
  null;
const SystemMessageChunk = (_props: {
  children: (chunk: StreamItemsChunk) => React.ReactElement;
}) => null;

/* SequenceItemsChunker is a stream message rendered
 * that chunks stream message together, when the sender
 * is the same and the timestamps are within a a certain threhold
 *
 * The chunking let us only render a cleaner, and more compact message
 * cell if a particpant quickly sends multiple messages in a row.
 */
class SequenceItemsChunker extends React.Component<Props> {
  static GapChunk: React.ReactElement;
  static DateChunk: React.ReactElement;
  static MessageChunk: React.ReactElement;
  static PhoneCallChunk: React.ReactElement;
  static VideoChatChunk: React.ReactElement;
  static SystemMessageChunk: React.ReactElement;

  static CHUNK_TYPE_TO_CHILD_TYPE = {
    GapItem: GapChunk,
    DateSeparator: DateChunk,
    MessageItem: MessageChunk,
    PhoneCallItem: PhoneCallChunk,
    VideoChatMessageInviteItem: VideoChatChunk,
    SystemMessageItem: SystemMessageChunk,
  };

  shouldComponentUpdate(_nextProps: Props) {
    //  This used to be more complicaded but it swalled updates,
    //  keeping the original code commented below but if we need
    //  that code we should probably rethink this whole chunker
    //  abstraction because it is very dated and awkward
    return true;
    //const newPage = this.props.items.length !== nextProps.items.length;
    //const newItem = this.props.items[0].key !== nextProps.items[0].key;

    //return newPage || newItem;
  }

  render(): React.ReactElement {
    if (this.props.items.length <= 0) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'ReactElemen... Remove this comment to see the full error message
      return null;
    }

    // @ts-expect-error ts-migrate(2739) FIXME: Type 'any[]' is missing the following properties f... Remove this comment to see the full error message
    return make(this.props.items).map((chunk) => {
      const childComponent = SequenceItemsChunker.CHUNK_TYPE_TO_CHILD_TYPE[chunk.type];
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '((_props: { children: (chunk: St... Remove this comment to see the full error message
      const childElement = childComponent && findByType(this.props.children, childComponent);

      return childElement ? (
        childElement.props.children(chunk)
      ) : (
        <ErrorReporter
          key={chunk.key()}
          error={`could not find child for chunk of type: ${chunk.type}`}
        />
      );
    });
  }
}

// @ts-expect-error ts-migrate(2322) FIXME: Type '(_props: { children: (chunk: StreamItemsChun... Remove this comment to see the full error message
SequenceItemsChunker.GapChunk = GapChunk;
// @ts-expect-error ts-migrate(2322) FIXME: Type '(_props: { children: (chunk: DateSeparatorCh... Remove this comment to see the full error message
SequenceItemsChunker.DateChunk = DateChunk;
// @ts-expect-error ts-migrate(2322) FIXME: Type '(_props: { children: (chunk: StreamItemsChun... Remove this comment to see the full error message
SequenceItemsChunker.MessageChunk = MessageChunk;
// @ts-expect-error ts-migrate(2322) FIXME: Type '(_props: { children: (chunk: StreamItemsChun... Remove this comment to see the full error message
SequenceItemsChunker.PhoneCallChunk = PhoneCallChunk;
// @ts-expect-error ts-migrate(2322) FIXME: Type '(_props: { children: (chunk: StreamItemsChun... Remove this comment to see the full error message
SequenceItemsChunker.VideoChatChunk = VideoChatChunk;
// @ts-expect-error ts-migrate(2322) FIXME: Type '(_props: { children: (chunk: StreamItemsChun... Remove this comment to see the full error message
SequenceItemsChunker.SystemMessageChunk = SystemMessageChunk;

export default SequenceItemsChunker;
